import React from 'react';
import { Check, Star } from 'lucide-react';
import { Button } from './ui/button';
import { packages } from '../mock';

const Services = ({ onContactClick }) => {
  return (
    <section id="packages" className="py-32 bg-black relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-brand-brown/20 to-black"></div>
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-brand-olive/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-brand-yellow/5 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-6xl mx-auto">
          {/* Section header */}
          <div className="text-center mb-20">
            <h2 className="text-5xl lg:text-6xl font-bold text-white mb-6 tracking-tight drop-shadow-[0_0_20px_rgba(255,255,255,0.4)]">
              Flexible Packages for Every Need
            </h2>
            <p className="text-xl lg:text-2xl text-white max-w-3xl mx-auto font-light drop-shadow-[0_2px_10px_rgba(0,0,0,0.8)]">
              Choose the perfect package to accelerate your digital growth. 
              No long-term contracts, cancel anytime.
            </p>
          </div>
          
          {/* Packages grid */}
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            {packages.map((pkg) => (
              <div 
                key={pkg.id}
                className={`relative rounded-3xl p-10 transition-all duration-500 hover:scale-105 hover:rotate-1 ${
                  pkg.popular 
                    ? 'bg-gradient-to-br from-brand-olive via-brand-olive/95 to-brand-olive/90 text-white shadow-2xl border-4 border-brand-yellow ring-4 ring-brand-yellow/20' 
                    : 'bg-gradient-to-br from-brand-brown/80 to-black/80 border-2 border-brand-olive/40 shadow-2xl hover:shadow-brand-olive/20 backdrop-blur-lg'
                }`}
              >
                {pkg.popular && (
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                    <div className="bg-brand-yellow text-brand-brown px-4 py-1 rounded-full text-sm font-bold flex items-center gap-1">
                      <Star className="w-4 h-4 fill-current" />
                      Most Popular
                    </div>
                  </div>
                )}
                
                <div className="mb-6">
                  <h3 className={`text-2xl font-bold mb-2 ${pkg.popular ? 'text-white' : 'text-white'}`}>
                    {pkg.name}
                  </h3>
                  <p className={`text-sm ${pkg.popular ? 'text-white/90' : 'text-brand-cream/70'}`}>
                    {pkg.description}
                  </p>
                </div>
                
                <div className="mb-8">
                  <div className="flex items-baseline gap-2">
                    <span className={`text-5xl font-bold ${pkg.popular ? 'text-white' : 'text-brand-yellow'}`}>
                      {pkg.price}
                    </span>
                    <span className={`text-lg ${pkg.popular ? 'text-white/80' : 'text-brand-cream/70'}`}>
                      /{pkg.period}
                    </span>
                  </div>
                </div>
                
                <ul className="space-y-4 mb-8">
                  {pkg.features.map((feature, index) => (
                    <li key={index} className="flex items-start gap-3">
                      <Check className={`w-5 h-5 flex-shrink-0 mt-0.5 ${
                        pkg.popular ? 'text-brand-yellow' : 'text-brand-olive'
                      }`} />
                      <span className={`text-sm ${pkg.popular ? 'text-white' : 'text-brand-cream/80'}`}>
                        {feature}
                      </span>
                    </li>
                  ))}
                </ul>
                
                <Button 
                  onClick={onContactClick}
                  className={`w-full py-6 text-lg font-semibold transition-all duration-300 ${
                    pkg.popular 
                      ? 'bg-white text-brand-olive hover:bg-brand-yellow hover:text-brand-brown' 
                      : 'bg-brand-olive text-white hover:bg-brand-brown'
                  }`}
                >
                  Get Started
                </Button>
              </div>
            ))}
          </div>
          
          {/* Add-on services */}
          <div className="text-center p-10 bg-gradient-to-r from-black via-brand-brown/40 to-black rounded-2xl border border-brand-olive/50 shadow-2xl backdrop-blur-lg">
            <h4 className="text-2xl font-bold text-brand-maroon mb-6 drop-shadow-[0_2px_8px_rgba(139,35,50,0.8)]">Add-On Services Available</h4>
            <p className="text-white max-w-3xl mx-auto text-lg leading-relaxed drop-shadow-[0_2px_6px_rgba(0,0,0,0.8)]">
              Website creation & landing page optimization • Extra social media posts & reels • 
              Premium video editing for TikTok/YouTube • Custom graphic design projects • SEO audit & optimization
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
